export const getInvoiceFormName = (sale = {}) => {
  const cart = Array.isArray(sale?.cart) ? sale.cart : [];
  return cart.some((item) => item?.type === "Subscription") ? "Subscription" : "Sale";
};

const asMessage = (value) => {
  if (typeof value === "string" && value.trim()) return value.trim();
  if (!value || typeof value !== "object") return "";
  return asMessage(value.message)
    || asMessage(value.error)
    || asMessage(value.detail);
};

export const getInvoiceEmailFailureMessage = (action) => (
  asMessage(action?.payload)
  || asMessage(action?.error)
  || "Unable to send the invoice email. Please try again."
);
